import React, { useEffect, useState } from 'react';
import { Card, Form, Input, Button, Row, Col, Space, Breadcrumb } from 'antd';
import { showSuccess, showError } from '../../../../components/errorHandler';
import { apiRequest } from '../../../../service/apiRequest';

const WhatsappSettings: React.FC = () => {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        setLoading(true);
        const response = await apiRequest({ method: 'get', url: '/whatsapp-setting' });
        console.log('Fetched Whatsapp settings:', response);
        if (response) {
          form.setFieldsValue(response);  // <-- This is correct
        }
      } catch (error) {
        showError('Failed to load Whatsapp settings');
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, [form]);
  const handleSave = async (values: any) => {
    try {
      await apiRequest({
        method: 'put',
        url: '/save-whatsapp-settings', // ✅ your backend endpoint
        data: values,
      });
      showSuccess('Whatsapp settings saved successfully');
    } catch (error) {
      showError('Failed to save Whatsapp settings');
    }
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }} size="large">
      <Breadcrumb items={[{ title: 'Dashboard' }, { title: 'Whatsapp Settings' }]} />
      <Row gutter={16} justify="center">
        <Col span={12}>
          <Card title="Whatsapp Settings">
            <Form
              layout="vertical"
              form={form}
              onFinish={handleSave}
              initialValues={{
                ws_whatsapp_sender_id: '',
                ws_whatsapp_api_key: '',
              }}
            >
              <Form.Item
                label="Sender ID"
                name="ws_whatsapp_sender_id"
                rules={[{ required: true, message: 'Sender ID is required' }]}
              >
                <Input placeholder="Enter whatsapp sender ID" />
              </Form.Item>

              <Form.Item
                label="API Key"
                name="ws_whatsapp_api_key"
                rules={[{ required: true, message: 'API Key is required' }]}
              >
                <Input.Password placeholder="Enter whatsapp API key" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  Save whatsapp Settings
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </Space>
  );
};

export default WhatsappSettings;
